import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";

export type A6Issuer = {
  id: number;
  name: string;
  country: string;
  country_name: string;
  sector: string;
  created_at: string;
  updated_at: string;
};

const tableName = "a6_issuers";
const t = (key: string, defaultValue: string) =>
  i18n.t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });

export const issuers_columns: ColumnDef<A6Issuer>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t("a6_issuers.columns.id", {
        ns: "tables",
        defaultValue: "Id",
      }),
  },
  {
    accessorKey: "name",
    header: t("name", "Name"),
  },
  {
    accessorKey: "country_name",
    header: t("country_name", "Country"),
  },
  {
    accessorKey: "sector",
    header: t("sector", "Sector"),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex gap-3 justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
